import getRegionalOptions from '../data/store/store';
import { getUserConfiguration } from 'owa-session-store';
import { select } from 'satcheljs/lib/legacy';
export default select({
    savedLocale: function () { return getUserConfiguration().SessionSettings.UserCulture; },
    selectedLocale: function () { return getRegionalOptions().selectedLocale; },
    supportedCultures: function () { return getRegionalOptions().supportedCultures; },
    supportedShortTimeFormats: function () { return getRegionalOptions().supportedShortTimeFormats; },
})(function getFilteredTimeFormatOptions(state) {
    var selectedLocaleName = state.selectedLocale || state.savedLocale;
    var selectedLocale = state.supportedCultures.filter(function (culture) { return culture.Name === selectedLocaleName; })[0];
    if (selectedLocale) {
        return state.supportedShortTimeFormats.filter(function (shortDateFormat, index) { return selectedLocale.ShortTimeFormatsIndexes.indexOf(index) >= 0; });
    }
    else {
        return [];
    }
});
//# sourceMappingURL=getFilteredTimeFormatOptions.js.map